<template>
  <b-container class="h-100">
    <b-row class="h-100" align-v="center">
      <b-col class="h-100">
        <b-row class="h-100" align-v="center" align-h="center">
          <b-col xs="12">
            <img class="logo" height="150px" src="../assets/WS_logo.svg">
            <p class="title">Printer Finder</p>
            <h4 class="subtext">Let us help you find the right printer for your needs </h4>
            <b-button size="lg" router-link :to="{ name: 'quiz', params: { page: 1 } }">
              <h3>begin</h3>
            </b-button>
          </b-col>
        </b-row>
      </b-col>
    </b-row>
  </b-container>
</template>

<style scoped>
.logo {
  max-width: 90vw;
}

.title {
  font-size: 4rem;
  padding: 48px 18px 0px ;
}

.subtext {
  padding: 0px 18px 48px
}
</style>


<script>
export default {};
</script>
